import { sqliteTable, text, real, index } from "drizzle-orm/sqlite-core";

// ============================================================================
// leave_allocations — สิทธิ์วันลา (Leave Allocation)
// ============================================================================
export const leaveAllocations = sqliteTable("hr_leave_allocations", {
  id: text("id").primaryKey(), // ULID
  companyId: text("company_id").notNull(),
  employeeId: text("employee_id").notNull(),
  leaveTypeId: text("leave_type_id").notNull(),
  fiscalYear: text("fiscal_year").notNull(), // e.g. "2569" or "2026"
  totalAllocated: real("total_allocated").notNull().default(0),
  used: real("used").notNull().default(0),
  balance: real("balance").notNull().default(0),
  // Audit columns
  createdBy: text("created_by"),
  createdAt: text("created_at").notNull(),
  updatedBy: text("updated_by"),
  updatedAt: text("updated_at").notNull(),
  deletedBy: text("deleted_by"),
  deletedAt: text("deleted_at"),
}, (table) => ({
  lal_company_employee_idx: index("lal_company_employee_idx").on(table.companyId, table.employeeId, table.fiscalYear),
  lal_leave_type_idx: index("lal_leave_type_idx").on(table.companyId, table.leaveTypeId, table.fiscalYear),
}));

// Type exports
export type LeaveAllocation = typeof leaveAllocations.$inferSelect;
export type NewLeaveAllocation = typeof leaveAllocations.$inferInsert;
